module.exports = __webpack_public_path__ + "static/media/1.b0f2b916.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/1.png
// module id = 749
// module chunks = 0